export async function calculateResignationDates(
  companyPolicy,
  resignationDetails
) {
  return new Promise((resolve) => {
    const {
      salary_release_type_id,
      salary_release_days,
      asset_return_type_id,
      asset_return_days_before,
      pending_amount_release_type_id,
      pending_amount_release_days,
      document_release_type_id,
      document_release_days,
      notice_period_days,
    } = companyPolicy;

    const { resignation_date } = resignationDetails;

    const resignationDate = new Date(resignation_date);
    const lastWorkingDate = new Date(resignationDate);
    lastWorkingDate.setDate(
      lastWorkingDate.getDate() +
        (resignationDetails?.notice_period_days
          ? resignationDetails?.notice_period_days
          : resignationDetails?.employment_status === "permanent"
          ? notice_period_days
          : 0)
    );

    const adjustDate = (date, days) => {
      let newDate = new Date(date);
      newDate.setDate(newDate.getDate() + days);
      return newDate.toISOString().split("T")[0];
    };

    const result = {
      last_working_date: resignationDetails?.last_working_date
        ? resignationDetails?.last_working_date
        : resignationDetails?.employment_status === "permanent"
        ? adjustDate(resignationDate, notice_period_days)
        : adjustDate(resignationDate, 0),
      salary_release_date:
        salary_release_type_id === 1
          ? adjustDate(lastWorkingDate, 1)
          : adjustDate(lastWorkingDate, salary_release_days),
      asset_return_due_date:
        resignationDetails?.employment_status !== "permanent"
          ? adjustDate(resignationDate, 0)
          : asset_return_type_id === 1
          ? adjustDate(lastWorkingDate, 0)
          : adjustDate(lastWorkingDate, -asset_return_days_before),
      pending_amount_release_date:
        pending_amount_release_type_id === 1
          ? adjustDate(lastWorkingDate, 1)
          : pending_amount_release_type_id === 2
          ? adjustDate(lastWorkingDate, pending_amount_release_days)
          : salary_release_type_id === 1
          ? adjustDate(lastWorkingDate, 1)
          : adjustDate(lastWorkingDate, salary_release_days),
      document_release_date:
        document_release_type_id === 1
          ? adjustDate(lastWorkingDate, 0)
          : adjustDate(lastWorkingDate, document_release_days),
    };

    resolve(result);
  });
}
